import { NeuTab } from "@neutron/react";
import React from "react";
import { interpolateColor } from "../../shared/hooks/utils";
import { GridColumn } from "../grid/Grid";

/**
 * Thin wrapper around `<NeuTablist>`
 * @NeutronUpdate The `<NeuTablist>` no longer exists in Neutron 3. This should get replaced with a GridRow
 */
export function NavTabContainer(props: { children: React.ReactNode, className?: string, color?: 'blue' | 'orange' | undefined }) {
    return (
        <NeuTab kind="plain" unit="group" color={props.color} className={props.className + interpolateColor(props.color)}>
            <GridColumn className='d-flex align-items-center' columns={12}>{props.children}</GridColumn>
        </NeuTab>
    )
}

/**
 * Wrapper around `<NeuTab>`
 * @NeutronUpdate `tabIndex` no longer exists in Neutron 3
 */

export function NavTab(props: { children: React.ReactNode, id?: string, className?: string, color?: string, onClick?: () => any, tabIndex?: number, active?: boolean  }) {
    return (
        <NeuTab unit="tab" active={props.active} id={props.id ?? ''} onClick={props.onClick} tabIndex={props.tabIndex}>
            {props.children}
        </NeuTab>
    )
}